module.exports = __webpack_public_path__ + "img/google-play-button.1ab83717.svg";